export default __webpack_public_path__ + "static/media/QuizAlarmApp.197b8bcf.jpg";